module.exports = __webpack_public_path__ + "static/media/blog-5.79ff0c49.png";